import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "inspect-multiple",
  "use": "inspect-multiple-usage",
  "viewBox": "0 0 44.55 52.39",
  "content": "<symbol viewBox=\"0 0 44.55 52.39\" id=\"inspect-multiple\"><title>资源 26</title><g id=\"inspect-multiple_图层_2\" data-name=\"图层 2\"><g id=\"inspect-multiple_图层_1-2\" data-name=\"图层 1\"><path d=\"M41.24,0H10.31A3.31,3.31,0,0,0,7,3.31V6H3.31A3.31,3.31,0,0,0,0,9.31V49.07a3.31,3.31,0,0,0,3.31,3.31H34.24a3.31,3.31,0,0,0,3.31-3.31V46.39h3.69a3.31,3.31,0,0,0,3.31-3.31V3.31A3.31,3.31,0,0,0,41.24,0ZM6.85,15.66a1.66,1.66,0,0,1,1.43-.83h8.84a1.66,1.66,0,0,1,0,3.31H8.28a1.66,1.66,0,0,1-1.43-2.48Zm0,6.63a1.66,1.66,0,0,1,1.43-.83h8.84a1.66,1.66,0,1,1,0,3.31H8.28a1.66,1.66,0,0,1-1.43-2.48ZM30.7,42.72a1.66,1.66,0,0,1-1.43.83h-21a1.66,1.66,0,1,1,0-3.31h21a1.66,1.66,0,0,1,1.43,2.49Zm0-6.63a1.66,1.66,0,0,1-1.43.83h-21a1.66,1.66,0,1,1,0-3.31h21A1.66,1.66,0,0,1,30.7,36.1Zm.22-12.43a1.1,1.1,0,0,1-1.1,1.1H23.19a1.1,1.1,0,0,1-1.1-1.1V15.94a1.1,1.1,0,0,1,1.1-1.1h6.63a1.1,1.1,0,0,1,1.1,1.1ZM41.24,39.21v3.87H37.55V9.31A3.31,3.31,0,0,0,34.24,6H10.31V3.31H41.24Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/inspect-multiple.svg
// module id = 8e2+
// module chunks = 264